/**
 * This function will ensure that the lexical rich text editor gets a valid string. When you give it an invalid json string the editor will crash
 * This function also has support for legacy description fields
 * @param content content value of the rich text editor
 * @returns stringified result for the rich text editor
 */
export const getInitialLexicalContentValue = (content = '') => {
   try {
      if (content === '') {
         throw new Error('Not a valid lexical string')
      }
      JSON.parse(content)
      return content
   } catch {
      // No content, or content is not a valid json string, return default.
      return JSON.stringify({
         root: {
            children: [
               {
                  children: [],  // Empty paragraph with no text nodes
                  direction: "ltr",
                  format: "",
                  indent: 0,
                  type: "paragraph",
                  version: 1
               }
            ],
            direction: "ltr",
            format: "",
            indent: 0,
            type: "root",
            version: 1
         }
      })
   }
}
